<template>
  <div class="unidade-areas-table mt-4">
    <div class="subtitle-2 mb-1">{{ $t('crudUnidades.areas.title') }}</div>
    <v-row v-if="canEdit" dense align="center">
      <v-col cols="10">
        <MultiplaEscolha
          ref="areasSelect"
          lazy
          get-url="getAreaslazy"
          text="nome_area"
          value="id_area"
          :item-label="rotuloArea"
          :label="$t('crudUnidades.areas.associate')"
          :max-items="3"
          v-bind:selected-items.sync="paraAssociar"
        />
      </v-col>
      <v-col cols="2" class="text-right">
        <v-btn
          color="primary"
          dark
          small
          fab
          :loading="salvando"
          :disabled="salvando || !paraAssociar.length"
          :title="$t('crudUnidades.areas.associate')"
          @click="associar"
        >
          <v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>
    <v-progress-linear v-if="loading" indeterminate color="primary" class="mb-2" />
    <v-chip-group column>
      <v-chip
        v-for="a in areas"
        :key="'ua-' + a.id_area"
        small
        :color="Number(a.zona_risco) === 1 ? 'red darken-2' : undefined"
        :text-color="Number(a.zona_risco) === 1 ? 'white' : undefined"
        :close="canEdit"
        @click:close="desassociar(a)"
      >
        <v-icon v-if="Number(a.zona_risco) === 1" x-small left>{{ iconeZonaRisco }}</v-icon>
        {{ rotuloArea(a) }}
      </v-chip>
    </v-chip-group>
    <div v-if="!loading && !areas.length" class="caption grey--text">{{ $t('crudUnidades.areas.empty') }}</div>
  </div>
</template>

<script>
import apiController from "@/utils/apiController";
import EventBus from "@/utils/eventBus";
import MultiplaEscolha from "@/components/Selects/MultiplaEscolha.vue";
import { rotuloArea } from "@/utils/areasGeometria";
import { ICONE_ZONA_RISCO } from "@/utils/areasMapa";

/**
 * Áreas de Planejamento de uma unidade, no cadastro de unidades. Associar aqui segue a regra
 * da área: unidade com cerca-centro fora do polígono é recusada pela API.
 */
export default {
  name: "UnidadeAreasTable",
  components: { MultiplaEscolha },
  props: {
    idUnidade: { type: [Number, String], required: true },
    canEdit: { type: Boolean, default: false },
  },
  data: () => ({
    areas: [],
    paraAssociar: [],
    loading: false,
    salvando: false,
    seq: 0,
    iconeZonaRisco: ICONE_ZONA_RISCO,
  }),
  watch: {
    idUnidade: { immediate: true, handler() { this.load(); } },
  },
  methods: {
    rotuloArea(a) {
      return rotuloArea(a) || String(a.id_area);
    },
    async load() {
      const seq = ++this.seq;
      if (this.idUnidade == null) {
        this.areas = [];
        return;
      }
      this.loading = true;
      try {
        const res = await apiController.request(apiController.endpoints.getAreasunidades, {
          data: [Number(this.idUnidade)],
          silent: true,
        });
        if (seq === this.seq) this.areas = Array.isArray(res.data) ? res.data : [];
      } catch (e) {
        if (seq === this.seq) this.areas = [];
      } finally {
        if (seq === this.seq) this.loading = false;
      }
    },
    mensagemErro(e) {
      const body = e && e.response && e.response.data;
      return (body && body.mensagem) || this.$t("system.messages.notPossibleUpdate");
    },
    async associar() {
      const ja = new Set(this.areas.map((a) => Number(a.id_area)));
      const ids = (this.paraAssociar || []).map(Number).filter((id) => Number.isFinite(id) && !ja.has(id));
      this.paraAssociar = [];
      const sel = this.$refs.areasSelect;
      if (sel && typeof sel.resetData === "function") sel.resetData();
      if (!ids.length) return;
      this.salvando = true;
      const erros = [];
      for (const idArea of ids) {
        try {
          await apiController.request(apiController.endpoints.associaUnidadesarea, {
            data: { id_area: idArea, id_unidades: [Number(this.idUnidade)] },
            silent: true,
          });
        } catch (e) {
          erros.push(this.mensagemErro(e));
        }
      }
      this.salvando = false;
      if (erros.length) EventBus.$emit("show-alert", { mensagem: erros.join("\n"), tipo: "error", duracao: 8000 });
      await this.load();
      this.$emit("changed");
    },
    async desassociar(area) {
      this.salvando = true;
      try {
        await apiController.request(apiController.endpoints.desassociaUnidadesarea, {
          data: { id_area: area.id_area, id_unidades: [Number(this.idUnidade)] },
          silent: true,
        });
        await this.load();
        this.$emit("changed");
      } catch (e) {
        EventBus.$emit("show-alert", { mensagem: this.mensagemErro(e), tipo: "error", duracao: 8000 });
      } finally {
        this.salvando = false;
      }
    },
  },
};
</script>
